module.exports = __webpack_public_path__ + "static/media/size_guide_banner_k.a0611d65.jpg";